import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {LoadingPage} from '../../../../../shared/components/loading/loading.page.component';
import {ScormCloudService} from '../../../../services/scorm-cloud.service';
import {NotificationService} from '../../../../services/notification.service';
import {FullscreenService} from '../../../../services/fullscreen.service';

@Component({
  selector: 'itpx-evaluation-scorm-cloud',
  templateUrl: './scorm-cloud.component.html',
  styleUrls: ['./scorm-cloud.component.css']
})
export class EvaluationScormCloudComponent extends LoadingPage implements OnInit, OnDestroy {

  private player: any;
  private deliverableId: any;
  private iframeUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private scormCloudService: ScormCloudService,
    private notificationService: NotificationService,
    private fullscreenService: FullscreenService,
  ) {
    super();
    this.player = window;
  }

  ngOnInit() {
    this.fullscreenService.onFullscreen()
      .skip(1)
      .subscribe(_ => this.router.navigate(['evaluation/dummy']));

    let routeData = this.route.params
      .take(1)
      .map(params => ({deliverableId: params['deliverableId'], registrationId: params['registrationId']}))
      .cacheResult();

    routeData
      .subscribe(data => this.deliverableId = data);

    // Initially start the scorm player
    routeData
      .flatMap(({deliverableId}) => this.scormCloudService.getCourses(deliverableId))
      .bindToLifecycle(this)
      .map(body => body.data)
      .subscribe(
        data => {
          this.ready();
          this.iframeUrl = data.previewUrl;
        },
        err => this.handleError(err)
      );
  }

  private handleError(error: any) {
    this.notificationService.error(error, 'Failed');
    this.ready();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/scormcloud/scorm-cloud.component.ts